// APP TEXT
export const APP_TITLE        = 'Pensiun Degonda'
export const APP_COMPANY_NAME = 'LOMBRISER & CO.'
export const APP_DESCRIPTION  = 'Web for Pensiun Degonda'
export const APP_VERSION = `${process.env.REACT_APP_VERSION}`

// UI CONSTANTS

// URLS
